












import Vue from "vue";
import Header from "@/components/layout/Header.vue";
import Footer from "@/components/layout/Footer.vue";
import ScollTopButton from "@/components/layout/ScollTopButton.vue";
import { authServiceInstance } from "./services/AuthService";
import { isProd } from "./services/libs/Utils";
import AlertService from "./services/libs/AlertService";
import router, { goToHome } from "./router";

export default Vue.extend({
  name: "App",
  components: {
    Header,
    Footer,
    ScollTopButton,
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "DataScout",
    // all titles will be injected into this template
    titleTemplate: "%s | IHSM",
  },
  beforeCreate() {
    // configure AuthService
    // add unauthorized handler to AuthService before components are mounted
    authServiceInstance.setUnauthorizedHandler(() => {
      // abort all other requests
      authServiceInstance.abortAll();
      goToHome();
    });
    // clear session after reponse is unauthorized
    authServiceInstance.clearSessionOnUnauthorizedException(true);
    if (
      !(
        this.$route?.path == "/" ||
        this.$route?.name?.toLowerCase() == "home" ||
        this.$route?.name?.toLowerCase() == "login"
      )
    )
      authServiceInstance.refreshToken().then((success) => {
        if (!success)
          AlertService.error(
            "Authentifizierung fehlgeschlagen,",
            "bitte melden Sie sich erneut an.",
          );
      });
  },
});
